import { DownloadTypes, KitStatuses } from '../constants';
import { html } from 'lit';

export interface KitItem {
  name: string;
  downloadType: number;
  id: string;
  kitId: string | number,
  dependencies: {
    feature: Array<number> | number | null;
    methods: Array<string> | null;
    parameters?: Object | null;
  };
  disabledMessage: string,
  label: string,
  event: any,
  disabled: boolean,
}

export interface GetDownloadTypeStatusesResponse {
  downloadTypeStatuses: { [key in DownloadTypes]: KitStatuses };
}

export interface CheckAccessToPackageResponse {
  status: KitStatuses;
  isImage: boolean;
}

export interface GetPackageCompanyRingVersionsResponse {
  pinnedVersion: {
    bestWin: any,
    bestLinux: any,
    bestMac: any
  }
}

export interface DownloadResponse {
  setupUrl: string;
  status: KitStatuses;
  isImage: boolean;
}

export enum PackagesEndpointMethodDownloadKit {
  GET_DOWNLOAD_TYPE_STATUSES = 'getDownloadTypeStatuses',
  DOWNLOAD = 'download',
  CHECK_ACCESS_TO_PACKAGE = 'checkAccessToPackage',
  GET_SELECTED_PACKAGE_COMPANY_RING_DETAILS = 'getPackageRingVersions'
}

export  interface MegaMenuSection {
  label: string,
  icon: string,
  items: Array<KitItem>
}

export type DownloadCallback = (kit: DownloadResponse) => void;
